export default __webpack_public_path__ + "static/media/mark_3.83cdcca4.png";